// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export {\n  menuText: #bfcbd9;\n  menuActiveText: #2b9ef7;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #000f29;\n  menuHover: rgba(38, 158, 247, 0.7);\n  subMenuBg: #000;\n  subMenuHover: rgba(38, 158, 247, 0.7);\n  sideBarWidth: 210px;\n  primaryColor: #2b9ef7;\n}\n.el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
